import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const BASE_URL = 'https://www.villaproistakis.gr'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Villa Proistakis – Luxury Villa Rentals in Ierapetra, Crete',
      description: 'Six luxury beachfront villas for rent in Ierapetra, Crete, Greece. Private pools, sea views, direct beach access, and full kitchens. Book your Mediterranean escape.',
      canonical: `${BASE_URL}/`
    }
  },
  {
    path: '/our-villas',
    name: 'our-villas',
    component: () => import('../views/OurVillasView.vue'),
    meta: {
      title: 'Our Villas – Luxury Beachfront Rentals in Crete | Villa Proistakis',
      description: 'Browse six handpicked luxury villas on the southern coast of Crete. Beachfront properties with private pools, sea views, and terraces in Ierapetra and Koutsouras.',
      canonical: `${BASE_URL}/our-villas`
    }
  },
  {
    path: '/discover',
    name: 'discover',
    component: () => import('../views/DiscoverView.vue'),
    meta: {
      title: 'Discover Ierapetra – Beaches & Restaurants | Villa Proistakis',
      description: 'Explore the best of southern Crete near our villas. Chrissi Island, Myrtos Beach, Koutsounari Long Beach, and top restaurants in Ierapetra.',
      canonical: `${BASE_URL}/discover`
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
    meta: {
      title: 'Contact Villa Proistakis – Book Your Stay in Crete',
      description: 'Get in touch with Villa Proistakis to enquire about availability, pricing, or to book one of our luxury villas in Ierapetra, Crete. We respond promptly.',
      canonical: `${BASE_URL}/contact`
    }
  },
  {
    path: '/villa/:id',
    name: 'villa',
    component: () => import('../views/VillaView.vue'),
    meta: {
      // Title/description are set dynamically in VillaView.vue
      titleTemplate: (name: string) => `${name} – Luxury Villa in Crete | Villa Proistakis`,
      descriptionTemplate: (name: string, desc: string) => desc.slice(0, 160)
    }
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// Update <title> and <meta name="description"> on every navigation
router.afterEach((to) => {
  const meta = to.meta as any

  // Title
  if (meta?.title) {
    document.title = meta.title
  }

  // Description
  const desc = meta?.description
  if (desc) {
    let el = document.querySelector('meta[name="description"]')
    if (!el) {
      el = document.createElement('meta')
      el.setAttribute('name', 'description')
      document.head.appendChild(el)
    }
    el.setAttribute('content', desc)
  }

  // OG title
  if (meta?.title) {
    let og = document.querySelector('meta[property="og:title"]')
    if (!og) {
      og = document.createElement('meta')
      og.setAttribute('property', 'og:title')
      document.head.appendChild(og)
    }
    og.setAttribute('content', meta.title)
  }

  // OG description
  if (desc) {
    let og = document.querySelector('meta[property="og:description"]')
    if (!og) {
      og = document.createElement('meta')
      og.setAttribute('property', 'og:description')
      document.head.appendChild(og)
    }
    og.setAttribute('content', desc)
  }

  // Canonical
  if (meta?.canonical) {
    let link = document.querySelector('link[rel="canonical"]')
    if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      document.head.appendChild(link)
    }
    link.setAttribute('href', meta.canonical)
  }

  // OG URL
  if (meta?.canonical) {
    let og = document.querySelector('meta[property="og:url"]')
    if (!og) {
      og = document.createElement('meta')
      og.setAttribute('property', 'og:url')
      document.head.appendChild(og)
    }
    og.setAttribute('content', meta.canonical)
  }
})

export default router
